import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import removeModalFromQuery from '../../../helpers/assessment/removeModalFromQuery';
import createMarkup from '../../../helpers/createMarkup';


export default function AssessDirectionsModal ({isOpen, directions, navTo, search}) {
  const noModalQuery = removeModalFromQuery(search)  
  const markup = directions ? createMarkup(directions) : {__html: '<p></p>'}
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => navTo(`?${noModalQuery}`)}
      className='modal-primary'
    >
      <ModalHeader
        toggle={() => navTo(`?${noModalQuery}`)}
      >
        Directions
      </ModalHeader>
      <ModalBody>
        <div
          dangerouslySetInnerHTML={markup}
        />
      </ModalBody>
    </Modal>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessDirectionsModal.js